import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useLayoutEffect } from "react";

/**
 * Drive `editor.setEditable` from a prop. A layout effect so the
 * `ContentEditable` re-render it triggers (the `contenteditable` DOM
 * attribute) is flushed before any passive effect tries to focus the editor.
 */
export function useLexicalEditableSync(editable: boolean): void {
  const [editor] = useLexicalComposerContext();
  useLayoutEffect(() => {
    if (editor.isEditable() !== editable) editor.setEditable(editable);
  }, [editor, editable]);
}
